export default {
  'merchantOnboarding.title': 'Merchant {{name}}',
  'merchantOnboarding.sectionTitle': 'Merchant {{name}}',
  'merchantOnboarding.error.title.request': 'Request Error',
  'merchantOnboarding.error.message.request': 'Error fetching data',
  'merchantOnboarding.merchant.title': 'Merchant Information',
  'merchantOnboarding.merchant.section.merchantDetails': 'Merchant Details',
  'merchantOnboarding.merchant.field.country': 'Country',
  'merchantOnboarding.merchant.field.companyName': 'Company Name',
  'merchantOnboarding.merchant.section.merchantRepresentative':
    'Merchant Representative',
  'merchantOnboarding.merchant.field.firstName': 'First Name',
  'merchantOnboarding.merchant.field.lastName': 'Last Name',
  'merchantOnboarding.merchant.field.contractNumber': 'Contract Number',
  'merchantOnboarding.merchant.field.emailAddress': 'Email Address',
  'merchantOnboarding.business.title': 'Business Information',
  'merchantOnboarding.business.section.trade': 'Trade',
  'merchantOnboarding.business.field.emirate': 'Emirate',
  'merchantOnboarding.business.field.tradeLicense': 'Trade License',
  'merchantOnboarding.business.section.address': 'Address',
  'merchantOnboarding.business.field.vatNumber': 'VAT Number',
  'merchantOnboarding.business.field.addressLine1': 'Address Line 1',
  'merchantOnboarding.business.field.city': 'City',
  'merchantOnboarding.business.field.addressLine2': 'Address Line 2',
  'merchantOnboarding.business.field.country': 'Country',
  'merchantOnboarding.business.field.poBox': 'PO Box',
  'merchantOnboarding.bank.title': 'Bank Information',
  'merchantOnboarding.bank.section.bank': 'Bank',
  'merchantOnboarding.bank.field.acquirerBank': 'Acquirer Bank',
  'merchantOnboarding.bank.field.bankName': 'Bank Name',
  'merchantOnboarding.bank.section.settlementDetails':
    'Account details for settlements',
  'merchantOnboarding.bank.field.ibanNumber': 'IBAN Number',
  'merchantOnboarding.bank.field.accountNumber': 'Account Number',
  'merchantOnboarding.bank.field.accountHolder':
    'Account Holder / Company Name',
};
